import axios from "axios";

import { getAuthToken } from "utilities";
import { SuccessResponseInterceptor, ErrorResponseInterceptor } from "./auth-interceptor";


const axiosInstance = axios.create({
    baseURL: process.env.BASE_URL
});

axiosInstance.interceptors.response.use(SuccessResponseInterceptor, ErrorResponseInterceptor);

axiosInstance.interceptors.request.use(_ => {
    _.headers.Authorization = `Bearer ${getAuthToken().authToken}`;
    return _;
});

export default {
    createRegion: (company_id, data) =>
        axiosInstance.post(`/company/region/${company_id}/create/`, data),
    getRegionList: (company_id) =>
        axiosInstance.get(`/company/region-list/${company_id}/`),
    getCompanyRegionList: (company_id) =>
        axiosInstance.get(`/company/${company_id}/facility-list/`),
    getCaseListInRegion: (company_region_id) =>
        axiosInstance.get(`/company/region/${company_region_id}/case-list/`)
};